"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var uploadIcon = function uploadIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("g", {
    fill: "#4d97fa"
  }, _react["default"].createElement("path", {
    d: "M185.749 81.664v204.501h42.667V81.664l70.251 70.251 30.165-30.166L207.083 0 85.333 121.749l30.166 30.166zM335.083 328.832v42.667h-256v-42.667H36.416v42.667c0 23.509 19.115 42.667 42.667 42.667h256c23.552 0 42.667-19.157 42.667-42.667v-42.667h-42.667z"
  })));
};

uploadIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 414.165 414.165",
  width: "512",
  height: "512"
};

var UTFileInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTFileInput, _PureComponent);

  function UTFileInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTFileInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTFileInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasDrag: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragLeave", function () {
      return _this.setState({
        hasDrag: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function (target) {
      return target && _this.setState({
        hasDrag: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDrop", function () {
      return _this.setState({
        hasDrag: false
      });
    });

    return _this;
  }

  _createClass(UTFileInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          name = _this$props.name,
          label = _this$props.label,
          loading = _this$props.loading,
          fileType = _this$props.fileType,
          error = _this$props.error,
          errorText = _this$props.errorText,
          Icon = _this$props.icon,
          uploadingText = _this$props.uploadingText,
          loadingTextClassname = _this$props.loadingTextClassname,
          classes = _this$props.classes,
          inputClassname = _this$props.inputClassname,
          errorClassname = _this$props.errorClassname,
          disabled = _this$props.disabled;
      var UploadImage = uploadIcon;
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "".concat(_stylesModule["default"].inputContainer, " ").concat(this.state.hasDrag && _stylesModule["default"].inputContainerDrag, " ").concat(loading && _stylesModule["default"].inputContainerLoading, " ").concat(classes.container),
        onDragLeave: this.handleDragLeave,
        onDragOver: this.handleDragOver,
        onDrop: this.handleOnDrop
      }, loading ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_UTLabel["default"], {
        gray: true,
        className: "".concat(_stylesModule["default"].loadingLabel, " ").concat(loadingTextClassname)
      }, uploadingText), _react["default"].createElement("div", {
        className: _stylesModule["default"].loading
      })) : _react["default"].createElement("div", {
        className: _stylesModule["default"].insideContainer
      }, Icon || _react["default"].createElement(UploadImage, {
        className: "".concat(_stylesModule["default"].icon, " ").concat(classes.icon)
      }), _react["default"].createElement(_UTLabel["default"], {
        primary: true,
        className: "".concat(_stylesModule["default"].label, " ").concat(classes.fileInputLabel)
      }, label)), _react["default"].createElement("input", {
        className: "".concat(_stylesModule["default"].input, " ").concat(inputClassname),
        accept: fileType,
        type: "file",
        onChange: onChange,
        name: name,
        disabled: disabled
      })), error && _react["default"].createElement(_UTLabel["default"], {
        small: true,
        className: "".concat(_stylesModule["default"].error, " ").concat(errorClassname)
      }, errorText));
    }
  }]);

  return UTFileInput;
}(_react.PureComponent);

UTFileInput.defaultProps = {
  label: _constants.SELECT_FILE,
  uploadingText: _constants.UPLOADING
};
UTFileInput.propTypes = {
  label: _propTypes.string,
  uploadingText: _propTypes.string,
  name: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  loading: _propTypes.string,
  fileType: _propTypes.string,
  error: _propTypes.bool,
  disabled: _propTypes.bool,
  errorText: _propTypes.string,
  icon: _propTypes.string,
  loadingTextClassname: _propTypes.string,
  classes: (0, _propTypes.shape)(_propTypes.any),
  inputClassname: _propTypes.string,
  errorClassname: _propTypes.string
};
var _default = UTFileInput;
exports["default"] = _default;